import React from "react";
import App from "./App";
import { Toaster } from "react-hot-toast";
import { BrowserRouter, Routes, Route } from "react-router-dom";

// GPA Routes for 2019 regulation
import {
  CSE,
  FirstSemCse,
  SecondSemCse,
  ThirdSemCse,
  FourthSemCse,
  FifthSemCse,
  SixthSemCse,
  SeventhSemCse,
  EighthSemCse,
} from "./containers/gpa/cse/index";
import {
  IT,
  FirstSemIt,
  SecondSemIt,
  ThirdSemIt,
  FourthSemIt,
  FifthSemIt,
  SixthSemIt,
  SeventhSemIt,
  EighthSemIt,
} from "./containers/gpa/it/index";
import {
  ECE,
  FirstSemEce,
  SecondSemEce,
  ThirdSemEce,
  FourthSemEce,
  FifthSemEce,
  SixthSemEce,
  SeventhSemEce,
  EightSemEce,
} from "./containers/gpa/ece/index";
import {
  EEE,
  FirstSemEee,
  SecondSemEee,
  ThirdSemEee,
  FourthSemEee,
  FifthSemEee,
  SixthSemEee,
  SeventhSemEee,
  EightSemEee,
} from "./containers/gpa/eee/index";
import {
  MECH,
  FirstSemMech,
  SecondSemMech,
  ThirdSemMech,
  FourthSemMech,
  FifthSemMech,
  SixthSemMech,
  SeventhSemMech,
  EightSemMech,
} from "./containers/gpa/mech/index";
import {
  AUTO,
  FirstSemAuto,
  SecondSemAuto,
  ThirdSemAuto,
  FourthSemAuto,
  FifthSemAuto,
  SixthSemAuto,
  SeventhSemAuto,
  EightSemAuto,
} from "./containers/gpa/auto/index";
import {
  CIVIL,
  FirstSemCivil,
  SecondSemCivil,
  ThirdSemCivil,
  FourthSemCivil,
  FifthSemCivil,
  SixthSemCivil,
  SeventhSemCivil,
  EightSemCivil,
} from "./containers/gpa/civil/index";
import {
  FT,
  FirstSemFt,
  SecondSemFt,
  ThirdSemFt,
  FourthSemFt,
  FifthSemFt,
  SixthSemFt,
  SeventhSemFt,
  EightSemFt,
} from "./containers/gpa/ft/index";
import {
  MCT,
  FirstSemMct,
  SecondSemMct,
  ThirdSemMct,
  FourthSemMct,
  FifthSemMct,
  SixthSemMct,
  SeventhSemMct,
  EightSemMct,
} from "./containers/gpa/mct/index";
import {
  AIML,
  FirstSemAiml,
  SecondSemAiml,
  ThirdSemAiml,
  FourthSemAiml,
  FifthSemAiml,
  SixthSemAiml,
  SeventhSemAiml,
  EighthSemAiml,
} from "./containers/gpa/aiml/index";
import {
  CSD,
  FirstSemCsd,
  SecondSemCsd,
  ThirdSemCsd,
  FourthSemCsd,
  FifthSemCsd,
  SixthSemCsd,
  SeventhSemCsd,
  EighthSemCsd,
} from "./containers/gpa/csd/index";
import {
  ADS,
  FirstSemAds,
  SecondSemAds,
  ThirdSemAds,
  FourthSemAds,
  FifthSemAds,
  SixthSemAds,
  SeventhSemAds,
  EighthSemAds,
} from "./containers/gpa/ads/index";



//2023 Regulation
import {
  CSE1,
  FirstSemCse1,
  SecondSemCse1,
  ThirdSemCse1,
  FourthSemCse1,
  FifthSemCse1,
  SixthSemCse1,
  SeventhSemCse1,
  // EighthSemCse1,
} from "./containers/gpa1/cse1/index";
import {
  IT1,
  FirstSemIt1,
  SecondSemIt1,
  ThirdSemIt1,
  FourthSemIt1,
  FifthSemIt1,
  SixthSemIt1,
  SeventhSemIt1,
  // EighthSemIt1,
} from "./containers/gpa1/it1/index";
import {
  ADS1,
  FirstSemAds1,
  SecondSemAds1,
  ThirdSemAds1,
  FourthSemAds1,
  FifthSemAds1,
  SixthSemAds1,
  SeventhSemAds1,
  // EighthSemAds1,
} from "./containers/gpa1/ads1/index";
import {
  AIML1,
  FirstSemAiml1,
  SecondSemAiml1,
  ThirdSemAiml1,
  FourthSemAiml1,
  FifthSemAiml1,
  SixthSemAiml1,
  SeventhSemAiml1,
  // EighthSemAiml1,
} from "./containers/gpa1/aiml1/index";
import {
  AUTO1,
  FirstSemAuto1,
  SecondSemAuto1,
  ThirdSemAuto1,
  FourthSemAuto1,
  FifthSemAuto1,
  SixthSemAuto1,
  SeventhSemAuto1,
  // EightSemAuto1,
} from "./containers/gpa1/auto1/index";
import {
  CIVIL1,
  FirstSemCivil1,
  SecondSemCivil1,
  ThirdSemCivil1,
  FourthSemCivil1,
  FifthSemCivil1,
  SixthSemCivil1,
  SeventhSemCivil1,
  // EightSemCivil1,
} from "./containers/gpa1/civil1/index";
import {
  CSD1,
  FirstSemCsd1,
  SecondSemCsd1,
  ThirdSemCsd1,
  FourthSemCsd1,
  FifthSemCsd1,
  SixthSemCsd1,
  SeventhSemCsd1,
  // EighthSemCsd1,
} from "./containers/gpa1/csd1/index";
import {
  ECE1,
  FirstSemEce1,
  SecondSemEce1,
  ThirdSemEce1,
  FourthSemEce1,
  FifthSemEce1,
  SixthSemEce1,
  SeventhSemEce1,
  // EightSemEce1,
} from "./containers/gpa1/ece1/index";
import {
  EEE1,
  FirstSemEee1,
  SecondSemEee1,
  ThirdSemEee1,
  FourthSemEee1,
  FifthSemEee1,
  SixthSemEee1,
  SeventhSemEee1,
  // EightSemEee1,
} from "./containers/gpa1/eee1/index";
import {
  MECH1,
  FirstSemMech1,
  SecondSemMech1,
  ThirdSemMech1,
  FourthSemMech1,
  FifthSemMech1,
  SixthSemMech1,
  SeventhSemMech1,
  // EightSemMech1,
} from "./containers/gpa1/mech1/index";
import {
  MCT1,
  FirstSemMct1,
  SecondSemMct1,
  ThirdSemMct1,
  FourthSemMct1,
  FifthSemMct1,
  SixthSemMct1,
  SeventhSemMct1,
  // EightSemMct1,
} from "./containers/gpa1/mct1/index";
import {
  FT1,
  FirstSemFt1,
  SecondSemFt1,
  ThirdSemFt1,
  FourthSemFt1,
  FifthSemFt1,
  SixthSemFt1,
  SeventhSemFt1,
  // EightSemFt1,
} from "./containers/gpa1/ft1/index";
import {
  ECCE1,
  FirstSemEcce1,
  SecondSemEcce1,
  ThirdSemEcce1,
  FourthSemEcce1,
  FifthSemEcce1,
  // SixthSemEcce1,
  // SeventhSemEcce1,
  // EightSemEcce1,
} from "./containers/gpa1/ecce1/index";
import {
  EECE1,
  FirstSemEece1,
  SecondSemEece1,
  ThirdSemEece1,
  FourthSemEece1,
  FifthSemEece1,
  // SixthSemEece1,
  // SeventhSemEece1,
  // EightSemEece1,
} from "./containers/gpa1/eece1/index";

import {
  CSB1,
  FirstSemCsb1,
  SecondSemCsb1,
  ThirdSemCsb1,
  // // FourthSemEece1,
  // // FifthSemEece1,
  // // SixthSemEece1,
  // // SeventhSemEece1,
  // // EightSemEece1,
} from "./containers/gpa1/csb1/index";
import {
  CSECS1,
  FirstSemcsecs1,
  SecondSemcsecs1,
  ThirdSemcsecs1,
  // FourthSemEece1,
  // FifthSemEece1,
  // SixthSemEece1,
  // SeventhSemEece1,
  // EightSemEece1,
} from "./containers/gpa1/csecs1/index";
import {
  FSE1,
  FirstSemFse1,
  SecondSemFse1,
  ThirdSemFse1,
  // FourthSemFse1,
  // FifthSemFse1,
  // SixthSemFse1,
  // SeventhSemFse1,
  // EightSemFse1,
} from "./containers/gpa1/fse1/index";
import {
  VLSI1,
  FirstSemVlsi1,
  SecondSemVlsi1,
  ThirdSemVlsi1,
  // FourthSemVlsi1,
  // FifthSemVlsi1,
  // SixthSemVlsi1,
  // SeventhSemVlsi1,
  // EightSemVlsi1,
} from "./containers/gpa1/vlsi1/index";




//2023 Regulation for 2025 Admitted Students
import {
  CSE2025,
  FirstSemCse2025,
  SecondSemCse2025,
  ThirdSemCse2025,
  // FourthSemCse2025,
  // FifthSemCse2025,
  // SixthSemCse2025,
  // SeventhSemCse2025,
  // EighthSemCse2025,
} from "./containers/gpa2025/cse2025/index";
import {
  IT2025,
  FirstSemIt2025,
  SecondSemIt2025,
  ThirdSemIt2025,
  // FourthSemIt2025,
  // FifthSemIt2025,
  // SixthSemIt2025,
  // SeventhSemIt2025,
  // EighthSemIt2025,
} from "./containers/gpa2025/it2025/index";
import {
  ADS2025,
  FirstSemAds2025,
  SecondSemAds2025,
  ThirdSemAds2025,
  // FourthSemAds2025,
  // FifthSemAds2025,
  // SixthSemAds2025,
  // SeventhSemAds2025,
  // EighthSemAds2025,
} from "./containers/gpa2025/ads2025/index";
import {
  AIML2025,
  FirstSemAiml2025,
  SecondSemAiml2025,
  ThirdSemAiml2025,
  // FourthSemAiml2025,
  // FifthSemAiml2025,
  // SixthSemAiml2025,
  // SeventhSemAiml2025,
  // EighthSemAiml2025,
} from "./containers/gpa2025/aiml2025/index";
import {
  AUTO2025,
  FirstSemAuto2025,
  SecondSemAuto2025,
  ThirdSemAuto2025,
  // FourthSemAuto2025,
  // FifthSemAuto2025,
  // SixthSemAuto2025,
  // SeventhSemAuto2025,
  // EightSemAuto2025,
} from "./containers/gpa2025/auto2025/index";
import {
  CIVIL2025,
  FirstSemCivil2025,
  SecondSemCivil2025,
  ThirdSemCivil2025,
  // FourthSemCivil2025,
  // FifthSemCivil2025,
  // SixthSemCivil2025,
  // SeventhSemCivil2025,
  // EightSemCivil2025,
} from "./containers/gpa2025/civil2025/index";
import {
  CSD2025,
  FirstSemCsd2025,
  SecondSemCsd2025,
  ThirdSemCsd2025,
  // FourthSemCsd2025,
  // FifthSemCsd2025,
  // SixthSemCsd2025,
  // SeventhSemCsd2025,
  // EighthSemCsd2025,
} from "./containers/gpa2025/csd2025/index";
import {
  ECE2025,
  FirstSemEce2025,
  SecondSemEce2025,
  ThirdSemEce2025,
  // FourthSemEce2025,
  // FifthSemEce2025,
  // SixthSemEce2025,
  // SeventhSemEce2025,
  // EightSemEce2025,
} from "./containers/gpa2025/ece2025/index";
import {
  EEE2025,
  FirstSemEee2025,
  SecondSemEee2025,
  ThirdSemEee2025,
  // FourthSemEee2025,
  // FifthSemEee2025,
  // SixthSemEee2025,
  // SeventhSemEee2025,
  // EightSemEee2025,
} from "./containers/gpa2025/eee2025/index";
import {
  MECH2025,
  FirstSemMech2025,
  SecondSemMech2025,
  ThirdSemMech2025,
  // FourthSemMech2025,
  // FifthSemMech2025,
  // SixthSemMech2025,
  // SeventhSemMech2025,
  // EightSemMech2025,
} from "./containers/gpa2025/mech2025/index";
import {
  MCT2025,
  FirstSemMct2025,
  SecondSemMct2025,
  ThirdSemMct2025,
  // FourthSemMct2025,
  // FifthSemMct2025,
  // SixthSemMct2025,
  // SeventhSemMct2025,
  // EightSemMct2025,
} from "./containers/gpa2025/mct2025/index";
import {
  FT2025,
  FirstSemFt2025,
  SecondSemFt2025,
  ThirdSemFt2025,
  // FourthSemFt2025,
  // FifthSemFt2025,
  // SixthSemFt2025,
  // SeventhSemFt2025,
  // EightSemFt2025,
} from "./containers/gpa2025/ft2025/index";
import {
  ECCE2025,
  FirstSemEcce2025,
  SecondSemEcce2025,
  ThirdSemEcce2025,
  // FourthSemEcce2025,
  // FifthSemEce2025,
  // SixthSemEce2025,
  // SeventhSemEce2025,
  // EightSemEce2025,
} from "./containers/gpa2025/ecce2025/index";
import {
  EECE2025,
  FirstSemEece2025,
  SecondSemEece2025,
  ThirdSemEece2025,
  // FourthSemEece2025,
  // FifthSemEece2025,
  // SixthSemEece2025,
  // SeventhSemEece2025,
  // EightSemEece2025,
} from "./containers/gpa2025/eece2025/index";
import {
  CSB2025,
  FirstSemCsb2025,
  SecondSemCsb2025,
  ThirdSemCsb2025,
  // FourthSemCsb2025,
  // FifthSemCsb2025,
  // SixthSemCsb2025,
  // SeventhSemCsb2025,
  // EightSemCsb2025,
} from "./containers/gpa2025/csb2025/index";
import {
  CSECS2025,
  FirstSemcsecs2025,
  SecondSemcsecs2025,
  ThirdSemcsecs2025,
  // FourthSemcsecs2025,
  // FifthSemcsecs2025,
  // SixthSemcsecs2025,
  // SeventhSemcsecs2025,
  // EightSemcsecs2025,
} from "./containers/gpa2025/csecs2025/index";
import {
  FSE2025,
  FirstSemFse2025,
  SecondSemFse2025,
  ThirdSemFse2025,
  // FourthSemFse2025,
  // FifthSemFse2025,
  // SixthSemFse2025,
  // SeventhSemFse2025,
  // EightSemFse2025,
} from "./containers/gpa2025/fse2025/index";
import {
  VLSI2025,
  FirstSemVlsi2025,
  SecondSemVlsi2025,
  ThirdSemVlsi2025,
  // FourthSemVlsi2025,
  // FifthSemVlsi2025,
  // SixthSemVlsi2025,
  // SeventhSemVlsi2025,
  // EightSemVlsi2025,
} from "./containers/gpa2025/vlsi2025/index";


// Syllabus Routes
import {
  Sem1Cse,
  Sem2Cse,
  Sem3Cse,
  Sem4Cse,
  Sem5Cse,
  Sem6Cse,
  Sem7Cse,
  Sem8Cse,
} from "./containers/syllabus/cse";
import {
  Sem1It,
  Sem2It,
  Sem3It,
  Sem4It,
  Sem5It,
  Sem6It,
  Sem7It,
  Sem8It,
} from "./containers/syllabus/it";
import {
  Sem1Ece,
  Sem2Ece,
  Sem3Ece,
  Sem4Ece,
  Sem5Ece,
  Sem6Ece,
  Sem7Ece,
  Sem8Ece,
} from "./containers/syllabus/ece";
import {
  Sem1Eee,
  Sem2Eee,
  Sem3Eee,
  Sem4Eee,
  Sem5Eee,
  Sem6Eee,
  Sem7Eee,
  Sem8Eee,
} from "./containers/syllabus/eee";
import {
  Sem1Mech,
  Sem2Mech,
  Sem3Mech,
  Sem4Mech,
  Sem5Mech,
  Sem6Mech,
  Sem7Mech,
  Sem8Mech,
} from "./containers/syllabus/mech";
import {
  Sem1Auto,
  Sem2Auto,
  Sem3Auto,
  Sem4Auto,
  Sem5Auto,
  Sem6Auto,
  Sem7Auto,
  Sem8Auto,
} from "./containers/syllabus/auto";
import {
  Sem1Civil,
  Sem2Civil,
  Sem3Civil,
  Sem4Civil,
  Sem5Civil,
  Sem6Civil,
  Sem7Civil,
  Sem8Civil,
} from "./containers/syllabus/civil";
import {
  Sem1Ads,
  Sem2Ads,
  Sem3Ads,
  Sem4Ads,
  Sem5Ads,
  Sem6Ads,
  Sem7Ads,
  Sem8Ads,
} from "./containers/syllabus/ads";
import {
  Sem1Csd,
  Sem2Csd,
  Sem3Csd,
  Sem4Csd,
  Sem5Csd,
  Sem6Csd,
  Sem7Csd,
  Sem8Csd,
} from "./containers/syllabus/csd";
import {
  Sem1Aiml,
  Sem2Aiml,
  Sem3Aiml,
  Sem4Aiml,
  Sem5Aiml,
  Sem6Aiml,
  Sem7Aiml,
  Sem8Aiml,
} from "./containers/syllabus/aiml";
import {
  Sem1Mct,
  Sem2Mct,
  Sem3Mct,
  Sem4Mct,
  Sem5Mct,
  Sem6Mct,
  Sem7Mct,
  Sem8Mct,
} from "./containers/syllabus/mct";
import {
  Sem1Ft,
  Sem2Ft,
  Sem3Ft,
  Sem4Ft,
  Sem5Ft,
  Sem6Ft,
  Sem7Ft,
  Sem8Ft,
} from "./containers/syllabus/ft";



//2023 syllabus
import {
  Sem1Cse1,
  Sem2Cse1,
  Sem3Cse1,
  Sem4Cse1,
  Sem5Cse1,
  Sem6Cse1,
  Sem7Cse1,
  Sem8Cse1,
} from "./containers/syllabus1/cse1";
import {
  Sem1It1,
  Sem2It1,
  Sem3It1,
  Sem4It1,
  Sem5It1,
  Sem6It1,
  Sem7It1,
  Sem8It1,
} from "./containers/syllabus1/it1";
import {
  Sem1Ece1,
  Sem2Ece1,
  Sem3Ece1,
  Sem4Ece1,
  Sem5Ece1,
  Sem6Ece1,
  Sem7Ece1,
  Sem8Ece1,
} from "./containers/syllabus1/ece1";
import {
  Sem1Eee1,
  Sem2Eee1,
  Sem3Eee1,
  Sem4Eee1,
  Sem5Eee1,
  Sem6Eee1,
  Sem7Eee1,
  Sem8Eee1,
} from "./containers/syllabus1/eee1";
import {
  Sem1Mech1,
  Sem2Mech1,
  Sem3Mech1,
  Sem4Mech1,
  Sem5Mech1,
  Sem6Mech1,
  Sem7Mech1,
  Sem8Mech1,
} from "./containers/syllabus1/mech1";
import {
  Sem1Auto1,
  Sem2Auto1,
  Sem3Auto1,
  Sem4Auto1,
  Sem5Auto1,
  Sem6Auto1,
  Sem7Auto1,
  Sem8Auto1,
} from "./containers/syllabus1/auto1";
import {
  Sem1Civil1,
  Sem2Civil1,
  Sem3Civil1,
  Sem4Civil1,
  Sem5Civil1,
  Sem6Civil1,
  Sem7Civil1,
  Sem8Civil1,
} from "./containers/syllabus1/civil1";
import {
  Sem1Ads1,
  Sem2Ads1,
  Sem3Ads1,
  Sem4Ads1,
  Sem5Ads1,
  Sem6Ads1,
  Sem7Ads1,
  Sem8Ads1,
} from "./containers/syllabus1/ads1";
import {
  Sem1Csd1,
  Sem2Csd1,
  Sem3Csd1,
  Sem4Csd1,
  Sem5Csd1,
  Sem6Csd1,
  Sem7Csd1,
  Sem8Csd1,
} from "./containers/syllabus1/csd1";
import {
  Sem1Aiml1,
  Sem2Aiml1,
  Sem3Aiml1,
  Sem4Aiml1,
  Sem5Aiml1,
  Sem6Aiml1,
  Sem7Aiml1,
  Sem8Aiml1,
} from "./containers/syllabus1/aiml1";

import {
  Sem1Mct1,
  Sem2Mct1,
  Sem3Mct1,
  Sem4Mct1,
  Sem5Mct1,
  Sem6Mct1,
  Sem7Mct1,
  Sem8Mct1,
} from "./containers/syllabus1/mct1";

import {
  Sem1Ft1,
  Sem2Ft1,
  Sem3Ft1,
  Sem4Ft1,
  Sem5Ft1,
  Sem6Ft1,
  Sem7Ft1,
  Sem8Ft1,
} from "./containers/syllabus1/ft1";

import {
  Sem1Ecce1,
  Sem2Ecce1,
  Sem3Ecce1,
  Sem4Ecce1,
  Sem5Ecce1,
  Sem6Ecce1,
  Sem7Ecce1,
  Sem8Ecce1,
} from "./containers/syllabus1/ecce1";

import {
  Sem1Eece1,
  Sem2Eece1,
  Sem3Eece1,
  Sem4Eece1,
  Sem5Eece1,
  Sem6Eece1,
  Sem7Eece1,
  Sem8Eece1,
} from "./containers/syllabus1/eece1";

import {
  Sem1Csb1,
  Sem2Csb1,
  Sem3Csb1,
  Sem4Csb1,
  Sem5Csb1,
  Sem6Csb1,
  Sem7Csb1,
  Sem8Csb1,
} from "./containers/syllabus1/csb1";

import {
  Sem1csecs1,
  Sem2csecs1,
  Sem3csecs1,
  Sem4csecs1,
  Sem5csecs1,
  Sem6csecs1,
  Sem7csecs1,
  Sem8csecs1,
} from "./containers/syllabus1/csecs1";

import {
  Sem1Vlsi1,
  Sem2Vlsi1,
  Sem3Vlsi1,
  Sem4Vlsi1,
  Sem5Vlsi1,
  Sem6Vlsi1,
  Sem7Vlsi1,
  Sem8Vlsi1,
} from "./containers/syllabus1/vlsi1";

import {
  Sem1Fse1,
  Sem2Fse1,
  Sem3Fse1,
  Sem4Fse1,
  Sem5Fse1,
  Sem6Fse1,
  Sem7Fse1,
  Sem8Fse1,
} from "./containers/syllabus1/fse1";


import GPA from "./containers/gpa/GPA";

import GPA1 from "./containers/gpa1/GPA1";

import GPA2025 from "./containers/gpa2025/GPA2025";

import MailForm from "./components/MailForm";

import NoPage from "./containers/NoPage";

import Header from "./components/header/Header";

import Footer from "./components/Footer";

import Syllabus from "./containers/syllabus/Syllabus";

import Syllabus1 from "./containers/syllabus1/Syllabus1";

import CGPA from "./containers/cgpa/CGPA";

import ScrollToTop from "./components/ScrollToTop";

import About from "./containers/about/About";

import Hall from "./containers/about/Hall";

import ExamSchedule from "./containers/about/Examschedule";

import Academic from "./containers/about/Academic";

import PreviousPapers from "./containers/previous/PreviousPapers";

import PreviousMaterials from "./containers/previous/PreviousMaterials";

const Router = () => {
  return (
    <BrowserRouter>
      <Toaster />
      <Header />
      <ScrollToTop>
        <Routes>
          <Route path="/" element={<App />} />

          {/* GPA Routes */}

          <Route path="/gpa" element={<GPA />} />
          <Route path="/gpa/cse" element={<CSE />} />
          <Route path="/gpa/cse/1sem" element={<FirstSemCse />} />
          <Route path="/gpa/cse/2sem" element={<SecondSemCse />} />
          <Route path="/gpa/cse/3sem" element={<ThirdSemCse />} />
          <Route path="/gpa/cse/4sem" element={<FourthSemCse />} />
          <Route path="/gpa/cse/5sem" element={<FifthSemCse />} />
          <Route path="/gpa/cse/6sem" element={<SixthSemCse />} />
          <Route path="/gpa/cse/7sem" element={<SeventhSemCse />} />
          <Route path="/gpa/cse/8sem" element={<EighthSemCse />} />

          <Route path="/gpa/it" element={<IT />} />
          <Route path="/gpa/it/1sem" element={<FirstSemIt />} />
          <Route path="/gpa/it/2sem" element={<SecondSemIt />} />
          <Route path="/gpa/it/3sem" element={<ThirdSemIt />} />
          <Route path="/gpa/it/4sem" element={<FourthSemIt />} />
          <Route path="/gpa/it/5sem" element={<FifthSemIt />} />
          <Route path="/gpa/it/6sem" element={<SixthSemIt />} />
          <Route path="/gpa/it/7sem" element={<SeventhSemIt />} />
          <Route path="/gpa/it/8sem" element={<EighthSemIt />} />

          <Route path="/gpa/ece" element={<ECE />} />
          <Route path="/gpa/ece/1sem" element={<FirstSemEce />} />
          <Route path="/gpa/ece/2sem" element={<SecondSemEce />} />
          <Route path="/gpa/ece/3sem" element={<ThirdSemEce />} />
          <Route path="/gpa/ece/4sem" element={<FourthSemEce />} />
          <Route path="/gpa/ece/5sem" element={<FifthSemEce />} />
          <Route path="/gpa/ece/6sem" element={<SixthSemEce />} />
          <Route path="/gpa/ece/7sem" element={<SeventhSemEce />} />
          <Route path="/gpa/ece/8sem" element={<EightSemEce />} />

          <Route path="/gpa/eee" element={<EEE />} />
          <Route path="/gpa/eee/1sem" element={<FirstSemEee />} />
          <Route path="/gpa/eee/2sem" element={<SecondSemEee />} />
          <Route path="/gpa/eee/3sem" element={<ThirdSemEee />} />
          <Route path="/gpa/eee/4sem" element={<FourthSemEee />} />
          <Route path="/gpa/eee/5sem" element={<FifthSemEee />} />
          <Route path="/gpa/eee/6sem" element={<SixthSemEee />} />
          <Route path="/gpa/eee/7sem" element={<SeventhSemEee />} />
          <Route path="/gpa/eee/8sem" element={<EightSemEee />} />

          <Route path="/gpa/mech" element={<MECH />} />
          <Route path="/gpa/mech/1sem" element={<FirstSemMech />} />
          <Route path="/gpa/mech/2sem" element={<SecondSemMech />} />
          <Route path="/gpa/mech/3sem" element={<ThirdSemMech />} />
          <Route path="/gpa/mech/4sem" element={<FourthSemMech />} />
          <Route path="/gpa/mech/5sem" element={<FifthSemMech />} />
          <Route path="/gpa/mech/6sem" element={<SixthSemMech />} />
          <Route path="/gpa/mech/7sem" element={<SeventhSemMech />} />
          <Route path="/gpa/mech/8sem" element={<EightSemMech />} />

          <Route path="/gpa/auto" element={<AUTO />} />
          <Route path="/gpa/auto/1sem" element={<FirstSemAuto />} />
          <Route path="/gpa/auto/2sem" element={<SecondSemAuto />} />
          <Route path="/gpa/auto/3sem" element={<ThirdSemAuto />} />
          <Route path="/gpa/auto/4sem" element={<FourthSemAuto />} />
          <Route path="/gpa/auto/5sem" element={<FifthSemAuto />} />
          <Route path="/gpa/auto/6sem" element={<SixthSemAuto />} />
          <Route path="/gpa/auto/7sem" element={<SeventhSemAuto />} />
          <Route path="/gpa/auto/8sem" element={<EightSemAuto />} />

          <Route path="/gpa/civil" element={<CIVIL />} />
          <Route path="/gpa/civil/1sem" element={<FirstSemCivil />} />
          <Route path="/gpa/civil/2sem" element={<SecondSemCivil />} />
          <Route path="/gpa/civil/3sem" element={<ThirdSemCivil />} />
          <Route path="/gpa/civil/4sem" element={<FourthSemCivil />} />
          <Route path="/gpa/civil/5sem" element={<FifthSemCivil />} />
          <Route path="/gpa/civil/6sem" element={<SixthSemCivil />} />
          <Route path="/gpa/civil/7sem" element={<SeventhSemCivil />} />
          <Route path="/gpa/civil/8sem" element={<EightSemCivil />} />

          <Route path="/gpa/ft" element={<FT/>} />
          <Route path="/gpa/ft/1sem" element={<FirstSemFt/>} />
          <Route path="/gpa/ft/2sem" element={<SecondSemFt/>} />
          <Route path="/gpa/ft/3sem" element={<ThirdSemFt/>} />
          <Route path="/gpa/ft/4sem" element={<FourthSemFt/>} />
          <Route path="/gpa/ft/5sem" element={<FifthSemFt/>} />
          <Route path="/gpa/ft/6sem" element={<SixthSemFt/>} />
          <Route path="/gpa/ft/7sem" element={<SeventhSemFt/>} />
          <Route path="/gpa/ft/8sem" element={<EightSemFt/>} />

          <Route path="/gpa/mct" element={<MCT />} />
          <Route path="/gpa/mct/1sem" element={<FirstSemMct/>} />
          <Route path="/gpa/mct/2sem" element={<SecondSemMct />} />
          <Route path="/gpa/mct/3sem" element={<ThirdSemMct />} />
          <Route path="/gpa/mct/4sem" element={<FourthSemMct />} />
          <Route path="/gpa/mct/5sem" element={<FifthSemMct />} />
          <Route path="/gpa/mct/6sem" element={<SixthSemMct />} />
          <Route path="/gpa/mct/7sem" element={<SeventhSemMct />} />
          <Route path="/gpa/mct/8sem" element={<EightSemMct />} />

          <Route path="/gpa/aiml" element={<AIML/>} />
          <Route path="/gpa/aiml/1sem" element={<FirstSemAiml/>} />
          <Route path="/gpa/aiml/2sem" element={<SecondSemAiml />} />
          <Route path="/gpa/aiml/3sem" element={<ThirdSemAiml />} />
          <Route path="/gpa/aiml/4sem" element={<FourthSemAiml />} />
          <Route path="/gpa/aiml/5sem" element={<FifthSemAiml />} />
          <Route path="/gpa/aiml/6sem" element={<SixthSemAiml />} />
          <Route path="/gpa/aiml/7sem" element={<SeventhSemAiml />} />
          <Route path="/gpa/aiml/8sem" element={<EighthSemAiml />} />

          <Route path="/gpa/csd" element={<CSD/>} />
          <Route path="/gpa/csd/1sem" element={<FirstSemCsd/>} />
          <Route path="/gpa/csd/2sem" element={<SecondSemCsd />} />
          <Route path="/gpa/csd/3sem" element={<ThirdSemCsd />} />
          <Route path="/gpa/csd/4sem" element={<FourthSemCsd />} />
          <Route path="/gpa/csd/5sem" element={<FifthSemCsd/>} />
          <Route path="/gpa/csd/6sem" element={<SixthSemCsd />} />
          <Route path="/gpa/csd/7sem" element={<SeventhSemCsd />} />
          <Route path="/gpa/csd/8sem" element={<EighthSemCsd/>} />

          <Route path="/gpa/ads" element={<ADS />} />
          <Route path="/gpa/ads/1sem" element={<FirstSemAds/>} />
          <Route path="/gpa/ads/2sem" element={<SecondSemAds />} />
          <Route path="/gpa/ads/3sem" element={<ThirdSemAds />} />
          <Route path="/gpa/ads/4sem" element={<FourthSemAds />} />
          <Route path="/gpa/ads/5sem" element={<FifthSemAds />} />
          <Route path="/gpa/ads/6sem" element={<SixthSemAds />} />
          <Route path="/gpa/ads/7sem" element={<SeventhSemAds />} />
          <Route path="/gpa/ads/8sem" element={<EighthSemAds />} />


          {/* GPA1 Routes 2023 Regulation */}

          <Route path="/gpa1" element={<GPA1 />} />
          <Route path="/gpa1/cse1" element={<CSE1 />} />
          <Route path="/gpa1/cse1/1sem" element={<FirstSemCse1 />} />
          <Route path="/gpa1/cse1/2sem" element={<SecondSemCse1 />} />
          <Route path="/gpa1/cse1/3sem" element={<ThirdSemCse1 />} />
          <Route path="/gpa1/cse1/4sem" element={<FourthSemCse1 />} />
          <Route path="/gpa1/cse1/5sem" element={<FifthSemCse1 />} />
          <Route path="/gpa1/cse1/6sem" element={<SixthSemCse1 />} />
          <Route path="/gpa1/cse1/7sem" element={<SeventhSemCse1 />} />
          {/* <Route path="/gpa1/cse1/8sem" element={<EighthSemCse1 />} /> */}

          <Route path="/gpa1/ads1" element={<ADS1 />} />
          <Route path="/gpa1/ads1/1sem" element={<FirstSemAds1/>} />
          <Route path="/gpa1/ads1/2sem" element={<SecondSemAds1 />} />
          <Route path="/gpa1/ads1/3sem" element={<ThirdSemAds1 />} />
          <Route path="/gpa1/ads1/4sem" element={<FourthSemAds1 />} />
          <Route path="/gpa1/ads1/5sem" element={<FifthSemAds1 />} />
          <Route path="/gpa1/ads1/6sem" element={<SixthSemAds1 />} />
          <Route path="/gpa1/ads1/7sem" element={<SeventhSemAds1 />} />
          {/* <Route path="/gpa1/ads1/8sem" element={<EighthSemAds1 />} /> */}

          <Route path="/gpa1/aiml1" element={<AIML1 />} />
          <Route path="/gpa1/aiml1/1sem" element={<FirstSemAiml1/>} />
          <Route path="/gpa1/aiml1/2sem" element={<SecondSemAiml1 />} />
          <Route path="/gpa1/aiml1/3sem" element={<ThirdSemAiml1 />} />
          <Route path="/gpa1/aiml1/4sem" element={<FourthSemAiml1 />} />
          <Route path="/gpa1/aiml1/5sem" element={<FifthSemAiml1 />} />
          <Route path="/gpa1/aiml1/6sem" element={<SixthSemAiml1 />} />
          <Route path="/gpa1/aiml1/7sem" element={<SeventhSemAiml1 />} />
          {/* <Route path="/gpa1/aiml1/8sem" element={<EighthSemAiml1 />} /> */}

          <Route path="/gpa1/auto1" element={<AUTO1 />} />
          <Route path="/gpa1/auto1/1sem" element={<FirstSemAuto1 />} />
          <Route path="/gpa1/auto1/2sem" element={<SecondSemAuto1 />} />
          <Route path="/gpa1/auto1/3sem" element={<ThirdSemAuto1 />} />
          <Route path="/gpa1/auto1/4sem" element={<FourthSemAuto1 />} />
          <Route path="/gpa1/auto1/5sem" element={<FifthSemAuto1 />} />
          <Route path="/gpa1/auto1/6sem" element={<SixthSemAuto1 />} />
          <Route path="/gpa1/auto1/7sem" element={<SeventhSemAuto1 />} />
          {/* <Route path="/gpa1/auto1/8sem" element={<EightSemAuto1 />} /> */}

          <Route path="/gpa1/civil1" element={<CIVIL1 />} />
          <Route path="/gpa1/civil1/1sem" element={<FirstSemCivil1 />} />
          <Route path="/gpa1/civil1/2sem" element={<SecondSemCivil1 />} />
          <Route path="/gpa1/civil1/3sem" element={<ThirdSemCivil1 />} />
          <Route path="/gpa1/civil1/4sem" element={<FourthSemCivil1 />} />
          <Route path="/gpa1/civil1/5sem" element={<FifthSemCivil1 />} />
          <Route path="/gpa1/civil1/6sem" element={<SixthSemCivil1 />} />
          <Route path="/gpa1/civil1/7sem" element={<SeventhSemCivil1 />} />
          {/* <Route path="/gpa1/civil1/8sem" element={<EighthSemCivil1 />} /> */}

          <Route path="/gpa1/csd1" element={<CSD1 />} />
          <Route path="/gpa1/csd1/1sem" element={<FirstSemCsd1/>} />
          <Route path="/gpa1/csd1/2sem" element={<SecondSemCsd1 />} />
          <Route path="/gpa1/csd1/3sem" element={<ThirdSemCsd1 />} />
          <Route path="/gpa1/csd1/4sem" element={<FourthSemCsd1 />} />
          <Route path="/gpa1/csd1/5sem" element={<FifthSemCsd1/>} />
          <Route path="/gpa1/csd1/6sem" element={<SixthSemCsd1 />} />
          <Route path="/gpa1/csd1/7sem" element={<SeventhSemCsd1 />} />
          {/* <Route path="/gpa1/csd1/8sem" element={<EighthSemCsd1/>} /> */}

          <Route path="/gpa1/ece1" element={<ECE1 />} />
          <Route path="/gpa1/ece1/1sem" element={<FirstSemEce1 />} />
          <Route path="/gpa1/ece1/2sem" element={<SecondSemEce1 />} />
          <Route path="/gpa1/ece1/3sem" element={<ThirdSemEce1 />} />
          <Route path="/gpa1/ece1/4sem" element={<FourthSemEce1 />} />
          <Route path="/gpa1/ece1/5sem" element={<FifthSemEce1 />} />
          <Route path="/gpa1/ece1/6sem" element={<SixthSemEce1 />} />
          <Route path="/gpa1/ece1/7sem" element={<SeventhSemEce1 />} />
          {/* <Route path="/gpa1/ece1/8sem" element={<EightSemEce1 />} /> */}

          <Route path="/gpa1/eee1" element={<EEE1 />} />
          <Route path="/gpa1/eee1/1sem" element={<FirstSemEee1 />} />
          <Route path="/gpa1/eee1/2sem" element={<SecondSemEee1 />} />
          <Route path="/gpa1/eee1/3sem" element={<ThirdSemEee1 />} />
          <Route path="/gpa1/eee1/4sem" element={<FourthSemEee1 />} />
          <Route path="/gpa1/eee1/5sem" element={<FifthSemEee1 />} />
          <Route path="/gpa1/eee1/6sem" element={<SixthSemEee1 />} />
          <Route path="/gpa1/eee1/7sem" element={<SeventhSemEee1 />} />
          {/* <Route path="/gpa1/eee1/8sem" element={<EightSemEee1 />} /> */}

          <Route path="/gpa1/it1" element={<IT1 />} />
          <Route path="/gpa1/it1/1sem" element={<FirstSemIt1 />} />
          <Route path="/gpa1/it1/2sem" element={<SecondSemIt1 />} />
          <Route path="/gpa1/it1/3sem" element={<ThirdSemIt1 />} />
          <Route path="/gpa1/it1/4sem" element={<FourthSemIt1 />} />
          <Route path="/gpa1/it1/5sem" element={<FifthSemIt1 />} />
          <Route path="/gpa1/it1/6sem" element={<SixthSemIt1 />} />
          <Route path="/gpa1/it1/7sem" element={<SeventhSemIt1 />} />
          {/* <Route path="/gpa1/it1/8sem" element={<EighthSemIt1 />} /> */}

          <Route path="/gpa1/mech1" element={<MECH1 />} />
          <Route path="/gpa1/mech1/1sem" element={<FirstSemMech1 />} />
          <Route path="/gpa1/mech1/2sem" element={<SecondSemMech1 />} />
          <Route path="/gpa1/mech1/3sem" element={<ThirdSemMech1 />} />
          <Route path="/gpa1/mech1/4sem" element={<FourthSemMech1 />} />
          <Route path="/gpa1/mech1/5sem" element={<FifthSemMech1 />} />
          <Route path="/gpa1/mech1/6sem" element={<SixthSemMech1 />} />
          <Route path="/gpa1/mech1/7sem" element={<SeventhSemMech1 />} />
          {/* <Route path="/gpa1/mech1/8sem" element={<EightSemMech1 />} /> */}

          <Route path="/gpa1/mct1" element={<MCT1 />} />
          <Route path="/gpa1/mct1/1sem" element={<FirstSemMct1/>} />
          <Route path="/gpa1/mct1/2sem" element={<SecondSemMct1 />} />
          <Route path="/gpa1/mct1/3sem" element={<ThirdSemMct1 />} />
          <Route path="/gpa1/mct1/4sem" element={<FourthSemMct1 />} />
          <Route path="/gpa1/mct1/5sem" element={<FifthSemMct1 />} />
          <Route path="/gpa1/mct1/6sem" element={<SixthSemMct1 />} />
          <Route path="/gpa1/mct1/7sem" element={<SeventhSemMct1 />} />
          {/* <Route path="/gpa1/mct1/8sem" element={<EightSemMct1 />} /> */}

          <Route path="/gpa1/ft1" element={<FT1/>} />
          <Route path="/gpa1/ft1/1sem" element={<FirstSemFt1/>} />
          <Route path="/gpa1/ft1/2sem" element={<SecondSemFt1/>} />
          <Route path="/gpa1/ft1/3sem" element={<ThirdSemFt1/>} />
          <Route path="/gpa1/ft1/4sem" element={<FourthSemFt1/>} />
          <Route path="/gpa1/ft1/5sem" element={<FifthSemFt1/>} />
          <Route path="/gpa1/ft1/6sem" element={<SixthSemFt1/>} />
          <Route path="/gpa1/ft1/7sem" element={<SeventhSemFt1/>} />
          {/* <Route path="/gpa1/ft1/8sem" element={<EightSemFt1/>} /> */}

          <Route path="/gpa1/ecce1" element={<ECCE1 />} />
          <Route path="/gpa1/ecce1/1sem" element={<FirstSemEcce1 />} />
          <Route path="/gpa1/ecce1/2sem" element={<SecondSemEcce1 />} />
          <Route path="/gpa1/ecce1/3sem" element={<ThirdSemEcce1 />} />
          <Route path="/gpa1/ecce1/4sem" element={<FourthSemEcce1 />} />
          <Route path="/gpa1/ecce1/5sem" element={<FifthSemEcce1 />} />
          {/* <Route path="/gpa1/ecce1/6sem" element={<SixthSemEcce1 />} />
          <Route path="/gpa1/ecce1/7sem" element={<SeventhSemEcce1 />} />
          <Route path="/gpa1/ecce1/8sem" element={<EightSemEcce1 />} /> */}

          <Route path="/gpa1/eece1" element={<EECE1 />} />
          <Route path="/gpa1/eece1/1sem" element={<FirstSemEece1 />} />
          <Route path="/gpa1/eece1/2sem" element={<SecondSemEece1 />} />
          <Route path="/gpa1/eece1/3sem" element={<ThirdSemEece1 />} />
          <Route path="/gpa1/eece1/4sem" element={<FourthSemEece1 />} />
          <Route path="/gpa1/eece1/5sem" element={<FifthSemEece1 />} />
          {/* <Route path="/gpa1/eece1/6sem" element={<SixthSemEece1 />} />
          <Route path="/gpa1/eece1/7sem" element={<SeventhSemEece1 />} />
          <Route path="/gpa1/eece1/8sem" element={<EightSemEece1 />} /> */}

          <Route path="/gpa1/csb1" element={<CSB1 />} />
          <Route path="/gpa1/csb1/1sem" element={<FirstSemCsb1 />} />
          <Route path="/gpa1/csb1/2sem" element={<SecondSemCsb1 />} />
          <Route path="/gpa1/csb1/3sem" element={<ThirdSemCsb1 />} />
          {/* <Route path="/gpa1/csb1/4sem" element={<FourthSemCsb1 />} />
          <Route path="/gpa1/csb1/5sem" element={<FifthSemCsb1 />} />
          <Route path="/gpa1/csb1/6sem" element={<SixthSemCsb1 />} />
          <Route path="/gpa1/csb1/7sem" element={<SeventhSemCsb1 />} />
          <Route path="/gpa1/csb1/8sem" element={<EightSemCsb1 />} /> */}

          <Route path="/gpa1/csecs1" element={<CSECS1 />} />
          <Route path="/gpa1/csecs1/1sem" element={<FirstSemcsecs1 />} />
          <Route path="/gpa1/csecs1/2sem" element={<SecondSemcsecs1 />} />
          <Route path="/gpa1/csecs1/3sem" element={<ThirdSemcsecs1 />} />
          {/* <Route path="/gpa1/csecs1/4sem" element={<FourthSemcsecs1 />} />
          <Route path="/gpa1/csecs1/5sem" element={<FifthSemcsecs1 />} />
          <Route path="/gpa1/csecs1/6sem" element={<SixthSemcsecs1 />} />
          <Route path="/gpa1/csecs1/7sem" element={<SeventhSemcsecs1 />} />
          <Route path="/gpa1/csecs1/8sem" element={<EighthSemcsecs1 />} /> */}

          <Route path="/gpa1/fse1" element={<FSE1 />} />
          <Route path="/gpa1/fse1/1sem" element={<FirstSemFse1 />} />
          <Route path="/gpa1/fse1/2sem" element={<SecondSemFse1 />} />
          <Route path="/gpa1/fse1/3sem" element={<ThirdSemFse1 />} />
          {/* <Route path="/gpa1/fse1/4sem" element={<FourthSemFse1 />} />
          <Route path="/gpa1/fse1/5sem" element={<FifthSemFse1 />} />
          <Route path="/gpa1/fse1/6sem" element={<SixthSemFse1 />} />
          <Route path="/gpa1/fse1/7sem" element={<SeventhSemFse1 />} />
          <Route path="/gpa1/fse1/8sem" element={<EightSemFse1 />} /> */}

          <Route path="/gpa1/vlsi1" element={<VLSI1 />} />
          <Route path="/gpa1/vlsi1/1sem" element={<FirstSemVlsi1 />} />
          <Route path="/gpa1/vlsi1/2sem" element={<SecondSemVlsi1 />} />
          <Route path="/gpa1/vlsi1/3sem" element={<ThirdSemVlsi1 />} />
          {/* <Route path="/gpa1/vlsi1/4sem" element={<FourthSemVlsi1 />} />
          <Route path="/gpa1/vlsi1/5sem" element={<FifthSemVlsi1 />} />
          <Route path="/gpa1/vlsi1/6sem" element={<SixthSemVlsi1 />} />
          <Route path="/gpa1/vlsi1/7sem" element={<SeventhSemVlsi1 />} />
          <Route path="/gpa1/vlsi1/8sem" element={<EightSemVlsi1 />} /> */}


          {/* GPA2025 Routes 2023 Regulation for 2025 Admitted Students*/}

          <Route path="/gpa2025" element={<GPA2025 />} />

          <Route path="/gpa2025/cse2025" element={<CSE2025 />} />
          <Route path="/gpa2025/cse2025/1sem" element={<FirstSemCse2025 />} />
          <Route path="/gpa2025/cse2025/2sem" element={<SecondSemCse2025 />} />
          <Route path="/gpa2025/cse2025/3sem" element={<ThirdSemCse2025 />} />
          {/* <Route path="/gpa2025/cse2025/4sem" element={<FourthSemCse2025 />} />
          <Route path="/gpa2025/cse2025/5sem" element={<FifthSemCse2025 />} />
          <Route path="/gpa2025/cse2025/6sem" element={<SixthSemCse2025 />} />
          <Route path="/gpa2025/cse2025/7sem" element={<SeventhSemCse2025 />} />
          <Route path="/gpa2025/cse2025/8sem" element={<EighthSemCse2025 />} /> */}

          <Route path="/gpa2025/ads2025" element={<ADS2025 />} />
          <Route path="/gpa2025/ads2025/1sem" element={<FirstSemAds2025/>} />
          <Route path="/gpa2025/ads2025/2sem" element={<SecondSemAds2025 />} />
          <Route path="/gpa2025/ads2025/3sem" element={<ThirdSemAds2025 />} />
          {/* <Route path="/gpa2025/ads2025/4sem" element={<FourthSemAds2025 />} />
          <Route path="/gpa2025/ads2025/5sem" element={<FifthSemAds2025 />} />
          <Route path="/gpa2025/ads2025/6sem" element={<SixthSemAds2025 />} />
          <Route path="/gpa2025/ads2025/7sem" element={<SeventhSemAds2025 />} />
          <Route path="/gpa2025/ads2025/8sem" element={<EighthSemAds2025 />} /> */}

          <Route path="/gpa2025/aiml2025" element={<AIML2025 />} />
          <Route path="/gpa2025/aiml2025/1sem" element={<FirstSemAiml2025/>} />
          <Route path="/gpa2025/aiml2025/2sem" element={<SecondSemAiml2025 />} />
          <Route path="/gpa2025/aiml2025/3sem" element={<ThirdSemAiml2025 />} />
          {/* <Route path="/gpa2025/aiml2025/4sem" element={<FourthSemAiml2025 />} />
          <Route path="/gpa2025/aiml2025/5sem" element={<FifthSemAiml2025 />} />
          <Route path="/gpa2025/aiml2025/6sem" element={<SixthSemAiml2025 />} />
          <Route path="/gpa2025/aiml2025/7sem" element={<SeventhSemAiml2025 />} />
          <Route path="/gpa2025/aiml2025/8sem" element={<EighthSemAiml2025 />} /> */}

          <Route path="/gpa2025/auto2025" element={<AUTO2025 />} />
          <Route path="/gpa2025/auto2025/1sem" element={<FirstSemAuto2025 />} />
          <Route path="/gpa2025/auto2025/2sem" element={<SecondSemAuto2025 />} />
          <Route path="/gpa2025/auto2025/3sem" element={<ThirdSemAuto2025 />} />
          {/* <Route path="/gpa2025/auto2025/4sem" element={<FourthSemAuto2025 />} />
          <Route path="/gpa2025/auto2025/5sem" element={<FifthSemAuto2025 />} />
          <Route path="/gpa2025/auto2025/6sem" element={<SixthSemAuto2025 />} />
            <Route path="/gpa2025/auto2025/7sem" element={<SeventhSemAuto2025 />} />
            <Route path="/gpa2025/auto2025/8sem" element={<EighthSemAuto2025 />} /> */}

          <Route path="/gpa2025/civil2025" element={<CIVIL2025 />} />
          <Route path="/gpa2025/civil2025/1sem" element={<FirstSemCivil2025 />} />
          <Route path="/gpa2025/civil2025/2sem" element={<SecondSemCivil2025 />} />
          <Route path="/gpa2025/civil2025/3sem" element={<ThirdSemCivil2025 />} />
          {/* <Route path="/gpa2025/civil2025/4sem" element={<FourthSemCivil2025 />} />
          <Route path="/gpa2025/civil2025/5sem" element={<FifthSemCivil2025 />} />
          <Route path="/gpa2025/civil2025/6sem" element={<SixthSemCivil2025 />} />
          <Route path="/gpa2025/civil2025/7sem" element={<SeventhSemCivil2025 />} />
          <Route path="/gpa2025/civil2025/8sem" element={<EighthSemCivil2025 />} /> */}

          <Route path="/gpa2025/csd2025" element={<CSD2025 />} />
          <Route path="/gpa2025/csd2025/1sem" element={<FirstSemCsd2025/>} />
          <Route path="/gpa2025/csd2025/2sem" element={<SecondSemCsd2025 />} />
          <Route path="/gpa2025/csd2025/3sem" element={<ThirdSemCsd2025 />} />
          {/* <Route path="/gpa2025/csd2025/4sem" element={<FourthSemCsd2025 />} />
          <Route path="/gpa2025/csd2025/5sem" element={<FifthSemCsd2025/>} />
          <Route path="/gpa2025/csd2025/6sem" element={<SixthSemCsd2025 />} />
          <Route path="/gpa2025/csd2025/7sem" element={<SeventhSemCsd2025 />} />
          <Route path="/gpa2025/csd2025/8sem" element={<EighthSemCsd2025/>} /> */}

          <Route path="/gpa2025/ece2025" element={<ECE2025 />} />
          <Route path="/gpa2025/ece2025/1sem" element={<FirstSemEce2025 />} />
          <Route path="/gpa2025/ece2025/2sem" element={<SecondSemEce2025 />} />
          <Route path="/gpa2025/ece2025/3sem" element={<ThirdSemEce2025 />} />
          {/* <Route path="/gpa2025/ece2025/4sem" element={<FourthSemEce2025 />} />
          <Route path="/gpa2025/ece2025/5sem" element={<FifthSemEce2025 />} />
          <Route path="/gpa2025/ece2025/6sem" element={<SixthSemEce2025 />} />
          <Route path="/gpa2025/ece2025/7sem" element={<SeventhSemEce2025 />} />
          <Route path="/gpa2025/ece2025/8sem" element={<EightSemEce2025 />} /> */}

          
          <Route path="/gpa2025/eee2025" element={<EEE2025 />} />
          <Route path="/gpa2025/eee2025/1sem" element={<FirstSemEee2025 />} />
          <Route path="/gpa2025/eee2025/2sem" element={<SecondSemEee2025 />} />
          <Route path="/gpa2025/eee2025/3sem" element={<ThirdSemEee2025 />} />
          {/* <Route path="/gpa2025/eee2025/4sem" element={<FourthSemEee2025 />} />
          <Route path="/gpa2025/eee2025/5sem" element={<FifthSemEee2025 />} />
          <Route path="/gpa2025/eee2025/6sem" element={<SixthSemEee2025 />} />
          <Route path="/gpa2025/eee2025/7sem" element={<SeventhSemEee2025 />} />
          <Route path="/gpa2025/eee2025/8sem" element={<EightSemEee2025 />} /> */}

          <Route path="/gpa2025/it2025" element={<IT2025 />} />
          <Route path="/gpa2025/it2025/1sem" element={<FirstSemIt2025 />} />
          <Route path="/gpa2025/it2025/2sem" element={<SecondSemIt2025 />} />
          <Route path="/gpa2025/it2025/3sem" element={<ThirdSemIt2025 />} />
          {/* <Route path="/gpa2025/it2025/4sem" element={<FourthSemIt2025 />} />
          <Route path="/gpa2025/it2025/5sem" element={<FifthSemIt2025 />} />
          <Route path="/gpa2025/it2025/6sem" element={<SixthSemIt2025 />} />
          <Route path="/gpa2025/it2025/7sem" element={<SeventhSemIt2025 />} />
          <Route path="/gpa2025/it2025/8sem" element={<EighthSemIt2025 />} /> */}

          <Route path="/gpa2025/mech2025" element={<MECH2025 />} />
          <Route path="/gpa2025/mech2025/1sem" element={<FirstSemMech2025 />} />
          <Route path="/gpa2025/mech2025/2sem" element={<SecondSemMech2025 />} />
          <Route path="/gpa2025/mech2025/3sem" element={<ThirdSemMech2025 />} />
          {/* <Route path="/gpa2025/mech2025/4sem" element={<FourthSemMech2025 />} />
          <Route path="/gpa2025/mech2025/5sem" element={<FifthSemMech2025 />} />
          <Route path="/gpa2025/mech2025/6sem" element={<SixthSemMech2025 />} />
          <Route path="/gpa2025/mech2025/7sem" element={<SeventhSemMech2025 />} />
          <Route path="/gpa2025/mech2025/8sem" element={<EighthSemMech2025 />} /> */}

          <Route path="/gpa2025/mct2025" element={<MCT2025 />} />
          <Route path="/gpa2025/mct2025/1sem" element={<FirstSemMct2025/>} />
          <Route path="/gpa2025/mct2025/2sem" element={<SecondSemMct2025 />} />
          <Route path="/gpa2025/mct2025/3sem" element={<ThirdSemMct2025 />} />
          {/* <Route path="/gpa2025/mct2025/4sem" element={<FourthSemMct2025 />} />
          <Route path="/gpa2025/mct2025/5sem" element={<FifthSemMct2025 />} />
          <Route path="/gpa2025/mct2025/6sem" element={<SixthSemMct2025 />} />
          <Route path="/gpa2025/mct2025/7sem" element={<SeventhSemMct2025 />} />
          <Route path="/gpa2025/mct2025/8sem" element={<EightSemMct2025 />} /> */}

          <Route path="/gpa2025/ft2025" element={<FT2025 />} />
          <Route path="/gpa2025/ft2025/1sem" element={<FirstSemFt2025/>} />
          <Route path="/gpa2025/ft2025/2sem" element={<SecondSemFt2025/>} />
          <Route path="/gpa2025/ft2025/3sem" element={<ThirdSemFt2025/>} />
          {/* <Route path="/gpa2025/ft2025/4sem" element={<FourthSemFt2025/>} />
          <Route path="/gpa2025/ft2025/5sem" element={<FifthSemFt2025/>} />
          <Route path="/gpa2025/ft2025/6sem" element={<SixthSemFt2025/>} />
          <Route path="/gpa2025/ft2025/7sem" element={<SeventhSemFt2025/>} />
          <Route path="/gpa2025/ft2025/8sem" element={<EightSemFt2025/>} /> */}

          <Route path="/gpa2025/ecce2025" element={<ECCE2025 />} />
          <Route path="/gpa2025/ecce2025/1sem" element={<FirstSemEcce2025 />} />
          <Route path="/gpa2025/ecce2025/2sem" element={<SecondSemEcce2025 />} />
          <Route path="/gpa2025/ecce2025/3sem" element={<ThirdSemEcce2025 />} />
          {/* <Route path="/gpa2025/ecce2025/4sem" element={<FourthSemEcce2025 />} />
          <Route path="/gpa2025/ecce2025/5sem" element={<FifthSemEcce2025 />} />
          <Route path="/gpa2025/ecce2025/6sem" element={<SixthSemEcce2025 />} />
          <Route path="/gpa2025/ecce2025/7sem" element={<SeventhSemEcce2025 />} />
          <Route path="/gpa2025/ecce2025/8sem" element={<EightSemEcce2025 />} /> */}

          <Route path="/gpa2025/eece2025" element={<EECE2025 />} />
          <Route path="/gpa2025/eece2025/1sem" element={<FirstSemEece2025 />} />
          <Route path="/gpa2025/eece2025/2sem" element={<SecondSemEece2025 />} />
          <Route path="/gpa2025/eece2025/3sem" element={<ThirdSemEece2025 />} />
          {/* <Route path="/gpa2025/eece2025/4sem" element={<FourthSemEece2025 />} />
          <Route path="/gpa2025/eece2025/5sem" element={<FifthSemEece2025 />} />
          <Route path="/gpa2025/eece2025/6sem" element={<SixthSemEece2025 />} />
          <Route path="/gpa2025/eece2025/7sem" element={<SeventhSemEece2025 />} />
          <Route path="/gpa2025/eece2025/8sem" element={<EightSemEece2025 />} /> */}

          <Route path="/gpa2025/csb2025" element={<CSB2025 />} />
          <Route path="/gpa2025/csb2025/1sem" element={<FirstSemCsb2025 />} />
          <Route path="/gpa2025/csb2025/2sem" element={<SecondSemCsb2025 />} />
          <Route path="/gpa2025/csb2025/3sem" element={<ThirdSemCsb2025 />} />
          {/* <Route path="/gpa2025/csb2025/4sem" element={<FourthSemCsb2025 />} />
          <Route path="/gpa2025/csb2025/5sem" element={<FifthSemCsb2025 />} />
          <Route path="/gpa2025/csb2025/6sem" element={<SixthSemCsb2025 />} />
          <Route path="/gpa2025/csb2025/7sem" element={<SeventhSemCsb2025 />} />
          <Route path="/gpa2025/csb2025/8sem" element={<EightSemCsb2025 />} /> */}

          <Route path="/gpa2025/csecs2025" element={<CSECS2025 />} />
          <Route path="/gpa2025/csecs2025/1sem" element={<FirstSemcsecs2025 />} />
          <Route path="/gpa2025/csecs2025/2sem" element={<SecondSemcsecs2025 />} />
          <Route path="/gpa2025/csecs2025/3sem" element={<ThirdSemcsecs2025 />} />
          {/* <Route path="/gpa2025/eece1/4sem" element={<FourthSemEece1 />} />
          <Route path="/gpa2025/eee1/5sem" element={<FifthSemEee1 />} />
          <Route path="/gpa2025/eee1/6sem" element={<SixthSemEee1 />} />
          <Route path="/gpa2025/eee1/7sem" element={<SeventhSemEee1 />} />
          <Route path="/gpa2025/eee1/8sem" element={<EightSemEee1 />} /> */}

          <Route path="/gpa2025/fse2025" element={<FSE2025 />} />
          <Route path="/gpa2025/fse2025/1sem" element={<FirstSemFse2025 />} />
          <Route path="/gpa2025/fse2025/2sem" element={<SecondSemFse2025 />} />
          <Route path="/gpa2025/fse2025/3sem" element={<ThirdSemFse2025 />} />
          {/* <Route path="/gpa2025/eece1/4sem" element={<FourthSemEece1 />} />
          <Route path="/gpa2025/eee1/5sem" element={<FifthSemEee1 />} />
          <Route path="/gpa2025/eee1/6sem" element={<SixthSemEee1 />} />
          <Route path="/gpa2025/eee1/7sem" element={<SeventhSemEee1 />} />
          <Route path="/gpa2025/eee1/8sem" element={<EightSemEee1 />} /> */}

          <Route path="/gpa2025/vlsi2025" element={<VLSI2025 />} />
          <Route path="/gpa2025/vlsi2025/1sem" element={<FirstSemVlsi2025 />} />
          <Route path="/gpa2025/vlsi2025/2sem" element={<SecondSemVlsi2025 />} />
          <Route path="/gpa2025/vlsi2025/3sem" element={<ThirdSemVlsi2025 />} />
          {/* <Route path="/gpa2025/eece1/4sem" element={<FourthSemEece1 />} />
          <Route path="/gpa2025/eee1/5sem" element={<FifthSemEee1 />} />
          <Route path="/gpa2025/eee1/6sem" element={<SixthSemEee1 />} />
          <Route path="/gpa2025/eee1/7sem" element={<SeventhSemEee1 />} />
          <Route path="/gpa2025/eee1/8sem" element={<EightSemEee1 />} /> */}
        
          {/* Syllabus Routes */}

          <Route path="/syllabus" element={<Syllabus />} />

          <Route path="/syllabus/cse" element={<CSE />} />
          <Route path="/syllabus/cse/1sem" element={<Sem1Cse />} />
          <Route path="/syllabus/cse/2sem" element={<Sem2Cse />} />
          <Route path="/syllabus/cse/3sem" element={<Sem3Cse />} />
          <Route path="/syllabus/cse/4sem" element={<Sem4Cse />} />
          <Route path="/syllabus/cse/5sem" element={<Sem5Cse />} />
          <Route path="/syllabus/cse/6sem" element={<Sem6Cse />} />
          <Route path="/syllabus/cse/7sem" element={<Sem7Cse />} />
          <Route path="/syllabus/cse/8sem" element={<Sem8Cse />} />

          <Route path="/syllabus/it" element={<IT />} />
          <Route path="/syllabus/it/1sem" element={<Sem1It />} />
          <Route path="/syllabus/it/2sem" element={<Sem2It />} />
          <Route path="/syllabus/it/3sem" element={<Sem3It />} />
          <Route path="/syllabus/it/4sem" element={<Sem4It />} />
          <Route path="/syllabus/it/5sem" element={<Sem5It />} />
          <Route path="/syllabus/it/6sem" element={<Sem6It />} />
          <Route path="/syllabus/it/7sem" element={<Sem7It />} />
          <Route path="/syllabus/it/8sem" element={<Sem8It />} />

          <Route path="/syllabus/ece" element={<ECE />} />
          <Route path="/syllabus/ece/1sem" element={<Sem1Ece />} />
          <Route path="/syllabus/ece/2sem" element={<Sem2Ece />} />
          <Route path="/syllabus/ece/3sem" element={<Sem3Ece />} />
          <Route path="/syllabus/ece/4sem" element={<Sem4Ece />} />
          <Route path="/syllabus/ece/5sem" element={<Sem5Ece />} />
          <Route path="/syllabus/ece/6sem" element={<Sem6Ece />} />
          <Route path="/syllabus/ece/7sem" element={<Sem7Ece />} />
          <Route path="/syllabus/ece/8sem" element={<Sem8Ece />} />

          <Route path="/syllabus/eee" element={<EEE />} />
          <Route path="/syllabus/eee/1sem" element={<Sem1Eee />} />
          <Route path="/syllabus/eee/2sem" element={<Sem2Eee />} />
          <Route path="/syllabus/eee/3sem" element={<Sem3Eee />} />
          <Route path="/syllabus/eee/4sem" element={<Sem4Eee />} />
          <Route path="/syllabus/eee/5sem" element={<Sem5Eee />} />
          <Route path="/syllabus/eee/6sem" element={<Sem6Eee />} />
          <Route path="/syllabus/eee/7sem" element={<Sem7Eee />} />
          <Route path="/syllabus/eee/8sem" element={<Sem8Eee />} />

          <Route path="/syllabus/mech" element={<MECH />} />
          <Route path="/syllabus/mech/1sem" element={<Sem1Mech />} />
          <Route path="/syllabus/mech/2sem" element={<Sem2Mech />} />
          <Route path="/syllabus/mech/3sem" element={<Sem3Mech />} />
          <Route path="/syllabus/mech/4sem" element={<Sem4Mech />} />
          <Route path="/syllabus/mech/5sem" element={<Sem5Mech />} />
          <Route path="/syllabus/mech/6sem" element={<Sem6Mech />} />
          <Route path="/syllabus/mech/7sem" element={<Sem7Mech />} />
          <Route path="/syllabus/mech/8sem" element={<Sem8Mech />} />

          <Route path="/syllabus/auto" element={<AUTO />} />
          <Route path="/syllabus/auto/1sem" element={<Sem1Auto />} />
          <Route path="/syllabus/auto/2sem" element={<Sem2Auto />} />
          <Route path="/syllabus/auto/3sem" element={<Sem3Auto />} />
          <Route path="/syllabus/auto/4sem" element={<Sem4Auto />} />
          <Route path="/syllabus/auto/5sem" element={<Sem5Auto />} />
          <Route path="/syllabus/auto/6sem" element={<Sem6Auto />} />
          <Route path="/syllabus/auto/7sem" element={<Sem7Auto />} />
          <Route path="/syllabus/auto/8sem" element={<Sem8Auto />} />

          <Route path="/syllabus/civil" element={<CIVIL />} />
          <Route path="/syllabus/civil/1sem" element={<Sem1Civil />} />
          <Route path="/syllabus/civil/2sem" element={<Sem2Civil />} />
          <Route path="/syllabus/civil/3sem" element={<Sem3Civil />} />
          <Route path="/syllabus/civil/4sem" element={<Sem4Civil />} />
          <Route path="/syllabus/civil/5sem" element={<Sem5Civil />} />
          <Route path="/syllabus/civil/6sem" element={<Sem6Civil />} />
          <Route path="/syllabus/civil/7sem" element={<Sem7Civil />} />
          <Route path="/syllabus/civil/8sem" element={<Sem8Civil />} />

          <Route path="/syllabus/ads" element={<ADS />} />
          <Route path="/syllabus/ads/1sem" element={<Sem1Ads />} />
          <Route path="/syllabus/ads/2sem" element={<Sem2Ads />} />
          <Route path="/syllabus/ads/3sem" element={<Sem3Ads />} />
          <Route path="/syllabus/ads/4sem" element={<Sem4Ads />} />
          <Route path="/syllabus/ads/5sem" element={<Sem5Ads />} />
          <Route path="/syllabus/ads/6sem" element={<Sem6Ads />} />
          <Route path="/syllabus/ads/7sem" element={<Sem7Ads />} />
          <Route path="/syllabus/ads/8sem" element={<Sem8Ads />} />

          <Route path="/syllabus/csd" element={<CSD />} />
          <Route path="/syllabus/csd/1sem" element={<Sem1Csd />} />
          <Route path="/syllabus/csd/2sem" element={<Sem2Csd />} />
          <Route path="/syllabus/csd/3sem" element={<Sem3Csd />} />
          <Route path="/syllabus/csd/4sem" element={<Sem4Csd />} />
          <Route path="/syllabus/csd/5sem" element={<Sem5Csd />} />
          <Route path="/syllabus/csd/6sem" element={<Sem6Csd />} />
          <Route path="/syllabus/csd/7sem" element={<Sem7Csd />} />
          <Route path="/syllabus/csd/8sem" element={<Sem8Csd />} />

          <Route path="/syllabus/aiml" element={<AIML />} />
          <Route path="/syllabus/aiml/1sem" element={<Sem1Aiml />} />
          <Route path="/syllabus/aiml/2sem" element={<Sem2Aiml />} />
          <Route path="/syllabus/aiml/3sem" element={<Sem3Aiml />} />
          <Route path="/syllabus/aiml/4sem" element={<Sem4Aiml />} />
          <Route path="/syllabus/aiml/5sem" element={<Sem5Aiml />} />
          <Route path="/syllabus/aiml/6sem" element={<Sem6Aiml />} />
          <Route path="/syllabus/aiml/7sem" element={<Sem7Aiml />} />
          <Route path="/syllabus/aiml/8sem" element={<Sem8Aiml />} />

          <Route path="/syllabus/mct" element={<MCT />} />
          <Route path="/syllabus/mct/1sem" element={<Sem1Mct />} />
          <Route path="/syllabus/mct/2sem" element={<Sem2Mct />} />
          <Route path="/syllabus/mct/3sem" element={<Sem3Mct />} />
          <Route path="/syllabus/mct/4sem" element={<Sem4Mct />} />
          <Route path="/syllabus/mct/5sem" element={<Sem5Mct />} />
          <Route path="/syllabus/mct/6sem" element={<Sem6Mct />} />
          <Route path="/syllabus/mct/7sem" element={<Sem7Mct />} />
          <Route path="/syllabus/mct/8sem" element={<Sem8Mct />} />

          <Route path="/syllabus/ft" element={<FT />} />
          <Route path="/syllabus/ft/1sem" element={<Sem1Ft />} />
          <Route path="/syllabus/ft/2sem" element={<Sem2Ft />} />
          <Route path="/syllabus/ft/3sem" element={<Sem3Ft />} />
          <Route path="/syllabus/ft/4sem" element={<Sem4Ft />} />
          <Route path="/syllabus/ft/5sem" element={<Sem5Ft />} />
          <Route path="/syllabus/ft/6sem" element={<Sem6Ft />} />
          <Route path="/syllabus/ft/7sem" element={<Sem7Ft />} />
          <Route path="/syllabus/ft/8sem" element={<Sem8Ft />} />


          {/* 2023 Syllabus Routes */}

          <Route path="/syllabus1" element={<Syllabus1 />} />

          <Route path="/syllabus1/cse1" element={<CSE1 />} />
          <Route path="/syllabus1/cse1/1sem" element={<Sem1Cse1 />} />
          <Route path="/syllabus1/cse1/2sem" element={<Sem2Cse1 />} />
          <Route path="/syllabus1/cse1/3sem" element={<Sem3Cse1 />} />
          <Route path="/syllabus1/cse1/4sem" element={<Sem4Cse1 />} />
          <Route path="/syllabus1/cse1/5sem" element={<Sem5Cse1 />} />
          <Route path="/syllabus1/cse1/6sem" element={<Sem6Cse1 />} />
          <Route path="/syllabus1/cse1/7sem" element={<Sem7Cse1 />} />
          <Route path="/syllabus1/cse1/8sem" element={<Sem8Cse1 />} />

          <Route path="/syllabus1/it1" element={<IT1 />} />
          <Route path="/syllabus1/it1/1sem" element={<Sem1It1 />} />
          <Route path="/syllabus1/it1/2sem" element={<Sem2It1 />} />
          <Route path="/syllabus1/it1/3sem" element={<Sem3It1 />} />
          <Route path="/syllabus1/it1/4sem" element={<Sem4It1 />} />
          <Route path="/syllabus1/it1/5sem" element={<Sem5It1 />} />
          <Route path="/syllabus1/it1/6sem" element={<Sem6It1 />} />
          <Route path="/syllabus1/it1/7sem" element={<Sem7It1 />} />
          <Route path="/syllabus1/it1/8sem" element={<Sem8It1 />} />

          <Route path="/syllabus1/ece1" element={<ECE1 />} />
          <Route path="/syllabus1/ece1/1sem" element={<Sem1Ece1 />} />
          <Route path="/syllabus1/ece1/2sem" element={<Sem2Ece1 />} />
          <Route path="/syllabus1/ece1/3sem" element={<Sem3Ece1 />} />
          <Route path="/syllabus1/ece1/4sem" element={<Sem4Ece1 />} />
          <Route path="/syllabus1/ece1/5sem" element={<Sem5Ece1 />} />
          <Route path="/syllabus1/ece1/6sem" element={<Sem6Ece1 />} />
          <Route path="/syllabus1/ece1/7sem" element={<Sem7Ece1 />} />
          <Route path="/syllabus1/ece1/8sem" element={<Sem8Ece1 />} />

          <Route path="/syllabus1/eee1" element={<EEE1 />} />
          <Route path="/syllabus1/eee1/1sem" element={<Sem1Eee1 />} />
          <Route path="/syllabus1/eee1/2sem" element={<Sem2Eee1 />} />
          <Route path="/syllabus1/eee1/3sem" element={<Sem3Eee1 />} />
          <Route path="/syllabus1/eee1/4sem" element={<Sem4Eee1 />} />
          <Route path="/syllabus1/eee1/5sem" element={<Sem5Eee1 />} />
          <Route path="/syllabus1/eee1/6sem" element={<Sem6Eee1 />} />
          <Route path="/syllabus1/eee1/7sem" element={<Sem7Eee1 />} />
          <Route path="/syllabus1/eee1/8sem" element={<Sem8Eee1 />} />

          <Route path="/syllabus1/mech1" element={<MECH1 />} />
          <Route path="/syllabus1/mech1/1sem" element={<Sem1Mech1 />} />
          <Route path="/syllabus1/mech1/2sem" element={<Sem2Mech1 />} />
          <Route path="/syllabus1/mech1/3sem" element={<Sem3Mech1 />} />
          <Route path="/syllabus1/mech1/4sem" element={<Sem4Mech1 />} />
          <Route path="/syllabus1/mech1/5sem" element={<Sem5Mech1 />} />
          <Route path="/syllabus1/mech1/6sem" element={<Sem6Mech1 />} />
          <Route path="/syllabus1/mech1/7sem" element={<Sem7Mech1 />} />
          <Route path="/syllabus1/mech1/8sem" element={<Sem8Mech1 />} />

          <Route path="/syllabus1/auto1" element={<AUTO1 />} />
          <Route path="/syllabus1/auto1/1sem" element={<Sem1Auto1 />} />
          <Route path="/syllabus1/auto1/2sem" element={<Sem2Auto1 />} />
          <Route path="/syllabus1/auto1/3sem" element={<Sem3Auto1 />} />
          <Route path="/syllabus1/auto1/4sem" element={<Sem4Auto1 />} />
          <Route path="/syllabus1/auto1/5sem" element={<Sem5Auto1 />} />
          <Route path="/syllabus1/auto1/6sem" element={<Sem6Auto1 />} />
          <Route path="/syllabus1/auto1/7sem" element={<Sem7Auto1 />} />
          <Route path="/syllabus1/auto1/8sem" element={<Sem8Auto1 />} />

          <Route path="/syllabus1/civil1" element={<CIVIL1 />} />
          <Route path="/syllabus1/civil1/1sem" element={<Sem1Civil1 />} />
          <Route path="/syllabus1/civil1/2sem" element={<Sem2Civil1 />} />
          <Route path="/syllabus1/civil1/3sem" element={<Sem3Civil1 />} />
          <Route path="/syllabus1/civil1/4sem" element={<Sem4Civil1 />} />
          <Route path="/syllabus1/civil1/5sem" element={<Sem5Civil1 />} />
          <Route path="/syllabus1/civil1/6sem" element={<Sem6Civil1 />} />
          <Route path="/syllabus1/civil1/7sem" element={<Sem7Civil1 />} />
          <Route path="/syllabus1/civil1/8sem" element={<Sem8Civil1 />} />

          <Route path="/syllabus1/ads1" element={<ADS1 />} />
          <Route path="/syllabus1/ads1/1sem" element={<Sem1Ads1 />} />
          <Route path="/syllabus1/ads1/2sem" element={<Sem2Ads1 />} />
          <Route path="/syllabus1/ads1/3sem" element={<Sem3Ads1 />} />
          <Route path="/syllabus1/ads1/4sem" element={<Sem4Ads1 />} />
          <Route path="/syllabus1/ads1/5sem" element={<Sem5Ads1 />} />
          <Route path="/syllabus1/ads1/6sem" element={<Sem6Ads1 />} />
          <Route path="/syllabus1/ads1/7sem" element={<Sem7Ads1 />} />
          <Route path="/syllabus1/ads1/8sem" element={<Sem8Ads1 />} />

          <Route path="/syllabus1/csd1" element={<CSD1 />} />
          <Route path="/syllabus1/csd1/1sem" element={<Sem1Csd1 />} />
          <Route path="/syllabus1/csd1/2sem" element={<Sem2Csd1 />} />
          <Route path="/syllabus1/csd1/3sem" element={<Sem3Csd1 />} />
          <Route path="/syllabus1/csd1/4sem" element={<Sem4Csd1 />} />
          <Route path="/syllabus1/csd1/5sem" element={<Sem5Csd1 />} />
          <Route path="/syllabus1/csd1/6sem" element={<Sem6Csd1 />} />
          <Route path="/syllabus1/csd1/7sem" element={<Sem7Csd1 />} />
          <Route path="/syllabus1/csd1/8sem" element={<Sem8Csd1 />} />

          <Route path="/syllabus1/aiml1" element={<AIML1 />} />
          <Route path="/syllabus1/aiml1/1sem" element={<Sem1Aiml1 />} />
          <Route path="/syllabus1/aiml1/2sem" element={<Sem2Aiml1 />} />
          <Route path="/syllabus1/aiml1/3sem" element={<Sem3Aiml1 />} />
          <Route path="/syllabus1/aiml1/4sem" element={<Sem4Aiml1 />} />
          <Route path="/syllabus1/aiml1/5sem" element={<Sem5Aiml1 />} />
          <Route path="/syllabus1/aiml1/6sem" element={<Sem6Aiml1 />} />
          <Route path="/syllabus1/aiml1/7sem" element={<Sem7Aiml1 />} />
          <Route path="/syllabus1/aiml1/8sem" element={<Sem8Aiml1 />} />

          <Route path="/syllabus1/mct1" element={<MCT1 />} />
          <Route path="/syllabus1/mct1/1sem" element={<Sem1Mct1 />} />
          <Route path="/syllabus1/mct1/2sem" element={<Sem2Mct1 />} />
          <Route path="/syllabus1/mct1/3sem" element={<Sem3Mct1 />} />
          <Route path="/syllabus1/mct1/4sem" element={<Sem4Mct1 />} />
          <Route path="/syllabus1/mct1/5sem" element={<Sem5Mct1 />} />
          <Route path="/syllabus1/mct1/6sem" element={<Sem6Mct1 />} />
          <Route path="/syllabus1/mct1/7sem" element={<Sem7Mct1 />} />
          <Route path="/syllabus1/mct1/8sem" element={<Sem8Mct1 />} />

          <Route path="/syllabus1/ft1" element={<FT1 />} />
          <Route path="/syllabus1/ft1/1sem" element={<Sem1Ft1 />} />
          <Route path="/syllabus1/ft1/2sem" element={<Sem2Ft1 />} />
          <Route path="/syllabus1/ft1/3sem" element={<Sem3Ft1 />} />
          <Route path="/syllabus1/ft1/4sem" element={<Sem4Ft1 />} />
          <Route path="/syllabus1/ft1/5sem" element={<Sem5Ft1 />} />
          <Route path="/syllabus1/ft1/6sem" element={<Sem6Ft1 />} />
          <Route path="/syllabus1/ft1/7sem" element={<Sem7Ft1 />} />
          <Route path="/syllabus1/ft1/8sem" element={<Sem8Ft1 />} />

          <Route path="/syllabus1/ecce1" element={<ECCE1 />} />
          <Route path="/syllabus1/ecce1/1sem" element={<Sem1Ecce1 />} />
          <Route path="/syllabus1/ecce1/2sem" element={<Sem2Ecce1 />} />
          <Route path="/syllabus1/ecce1/3sem" element={<Sem3Ecce1 />} />
          <Route path="/syllabus1/ecce1/4sem" element={<Sem4Ecce1 />} />
          <Route path="/syllabus1/ecce1/5sem" element={<Sem5Ecce1 />} />
          <Route path="/syllabus1/ecce1/6sem" element={<Sem6Ecce1 />} />
          <Route path="/syllabus1/ecce1/7sem" element={<Sem7Ecce1 />} />
          <Route path="/syllabus1/ecce1/8sem" element={<Sem8Ecce1 />} />

          <Route path="/syllabus1/eece1" element={<EECE1 />} />
          <Route path="/syllabus1/eece1/1sem" element={<Sem1Eece1 />} />
          <Route path="/syllabus1/eece1/2sem" element={<Sem2Eece1 />} />
          <Route path="/syllabus1/eece1/3sem" element={<Sem3Eece1 />} />
          <Route path="/syllabus1/eece1/4sem" element={<Sem4Eece1 />} />
          <Route path="/syllabus1/eece1/5sem" element={<Sem5Eece1 />} />
          <Route path="/syllabus1/eece1/6sem" element={<Sem6Eece1 />} />
          <Route path="/syllabus1/eece1/7sem" element={<Sem7Eece1 />} />
          <Route path="/syllabus1/eece1/8sem" element={<Sem8Eece1 />} />

          <Route path="/syllabus1/csb1" element={<CSB1 />} />
          <Route path="/syllabus1/csb1/1sem" element={<Sem1Csb1 />} />
          <Route path="/syllabus1/csb1/2sem" element={<Sem2Csb1 />} />
          <Route path="/syllabus1/csb1/3sem" element={<Sem3Csb1 />} />
          <Route path="/syllabus1/csb1/4sem" element={<Sem4Csb1 />} />
          <Route path="/syllabus1/csb1/5sem" element={<Sem5Csb1 />} />
          <Route path="/syllabus1/csb1/6sem" element={<Sem6Csb1 />} />
          <Route path="/syllabus1/csb1/7sem" element={<Sem7Csb1 />} />
          <Route path="/syllabus1/csb1/8sem" element={<Sem8Csb1 />} />

          <Route path="/syllabus1/csecs1" element={<CSECS1 />} />
          <Route path="/syllabus1/csecs1/1sem" element={<Sem1csecs1 />} />
          <Route path="/syllabus1/csecs1/2sem" element={<Sem2csecs1 />} />
          <Route path="/syllabus1/csecs1/3sem" element={<Sem3csecs1 />} />
          <Route path="/syllabus1/csecs1/4sem" element={<Sem4csecs1 />} />
          <Route path="/syllabus1/csecs1/5sem" element={<Sem5csecs1 />} />
          <Route path="/syllabus1/csecs1/6sem" element={<Sem6csecs1 />} />
          <Route path="/syllabus1/csecs1/7sem" element={<Sem7csecs1 />} />
          <Route path="/syllabus1/csecs1/8sem" element={<Sem8csecs1 />} />

          <Route path="/syllabus1/vlsi1" element={<VLSI1 />} />
          <Route path="/syllabus1/vlsi1/1sem" element={<Sem1Vlsi1 />} />
          <Route path="/syllabus1/vlsi1/2sem" element={<Sem2Vlsi1 />} />
          <Route path="/syllabus1/vlsi1/3sem" element={<Sem3Vlsi1 />} />
          <Route path="/syllabus1/vlsi1/4sem" element={<Sem4Vlsi1 />} />
          <Route path="/syllabus1/vlsi1/5sem" element={<Sem5Vlsi1 />} />
          <Route path="/syllabus1/vlsi1/6sem" element={<Sem6Vlsi1 />} />
          <Route path="/syllabus1/vlsi1/7sem" element={<Sem7Vlsi1 />} />
          <Route path="/syllabus1/vlsi1/8sem" element={<Sem8Vlsi1 />} />

          <Route path="/syllabus1/fse1" element={<FSE1 />} />
          <Route path="/syllabus1/fse1/1sem" element={<Sem1Fse1 />} />
          <Route path="/syllabus1/fse1/2sem" element={<Sem2Fse1 />} />
          <Route path="/syllabus1/fse1/3sem" element={<Sem3Fse1 />} />
          <Route path="/syllabus1/fse1/4sem" element={<Sem4Fse1 />} />
          <Route path="/syllabus1/fse1/5sem" element={<Sem5Fse1 />} />
          <Route path="/syllabus1/fse1/6sem" element={<Sem6Fse1 />} />
          <Route path="/syllabus1/fse1/7sem" element={<Sem7Fse1 />} />
          <Route path="/syllabus1/fse1/8sem" element={<Sem8Fse1 />} />


          <Route path="/cgpa" element={<CGPA />} />

          <Route path="/previous-papers" element={<PreviousPapers />} />

          <Route path="/previous-materials" element={<PreviousMaterials />} />

          <Route path="/about" element={<About />} />

          <Route path="/hall" element={<Hall />} />

          <Route path="/examschedule/:regulation" element={<ExamSchedule />} />

          <Route path="/academic" element={<Academic />} />

          <Route path="mailForm" element={<MailForm />} />
          <Route path="*" element={<NoPage />} />
          
        </Routes>
      </ScrollToTop>
      <Footer />
    </BrowserRouter>
  );
};

export default Router;
